import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { GooglePayService } from '../../services/google-pay.service';
import { PaymentMethod } from '../../models/cart.model';

export type PaymentOptionResult = PaymentMethod;

@Component({
  selector: 'app-payment-options-sheet',
  templateUrl: './payment-options-sheet.html',
  styleUrls: ['./payment-options-sheet.scss'],
  standalone: false
})
export class PaymentOptionsSheetComponent implements OnChanges {
  @Input() paymentMethods: PaymentMethod[] = [];
  @Input() disabled = false;
  @Output() optionSelected = new EventEmitter<PaymentOptionResult>();

  constructor(private googlePayService: GooglePayService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['paymentMethods']) {
      this.setupGooglePayButton();
    }
  }

  private setupGooglePayButton(): void {
    const googlePayMethod = this.paymentMethods.find((method) => method.key === 'googlepay');
    if (!googlePayMethod) return;

    setTimeout(() => {
      this.googlePayService
        .showGooglePayButton('gpay-button-container', () => this.selectMethod(googlePayMethod))
        .catch(() => { });
    }, 0);
  }

  selectMethod(method: PaymentMethod): void {
    if (this.disabled) return;
    this.optionSelected.emit(method);
  }
}
